import { useState, useRef, useEffect } from "react";
import { styled } from "@mui/system";
import { Box } from "@mui/material";
import { toast } from "react-toastify";

const DropdownContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",

  "& input": {
    width: "100%",
    padding: "10px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
    cursor: "pointer",
  },

  "& .dropdown-list": {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "4px",
    maxHeight: "200px",
    overflowY: "auto",
    zIndex: 10,
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  },

  "& .dropdown-item": {
    padding: "10px 15px",
    cursor: "pointer",
    transition: "background-color 0.2s",

    "&:hover": {
      backgroundColor: "#f5f5f5",
    },

    "&.selected": {
      backgroundColor: "#e0e0e0",
    },
  },
}));

const TimeLimitDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const dropdownRef = useRef(null);

 
  const timeOptions = [5, 10, 15, 20, 30, 45, 60, 90, 120];

  useEffect(() => {
   
    if (value === "" || /^\d+$/.test(value)) {
      setInputValue(value);
    }
  }, [value]);

  useEffect(() => {

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleInputFocus = () => {
    setIsOpen(true);
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;

    if (newValue === "" || /^\d+$/.test(newValue)) {
      setInputValue(newValue);
      onChange({ target: { value: newValue } });
    } else {
      toast.error("Please enter a valid number.");
    }
  };

  const handleOptionSelect = (option) => {
    setInputValue(option.toString());
    onChange({ target: { value: option.toString() } });
    setIsOpen(false);
  };

  return (
    <DropdownContainer ref={dropdownRef}>
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onFocus={handleInputFocus}
        placeholder="Select time limit or enter value"
        inputMode="numeric"
        pattern="[0-9]*"
      />

      {isOpen && (
        <div className="dropdown-list">
          {timeOptions.map((option) => (
            <div
              key={option}
              className={`dropdown-item ${inputValue === option.toString() ? "selected" : ""}`}
              onClick={() => handleOptionSelect(option)}
            >
              {option} minutes
            </div>
          ))}
        </div>
      )}
    </DropdownContainer>
  );
};

export default TimeLimitDropdown;
